/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {platformJsonFilter} from '../../../pages/orgManager/Utils/OrgProfile/Forms/Constants/Common';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const processTypeJSON = async (): Promise<any> => {
  const {processType, setProcessType} = useJSONStore.getState();
  const {companyDetails} = useCompanyStore.getState();
  const token = useUserStore.getState().userToken;

  if (processType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.processType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        const subCatergory = res.data.data.filter((item: any) => {
          return item?.subCategoryId.includes(companyDetails.subCategory);
        });
        setProcessType(platformJsonFilter(subCatergory));
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default processTypeJSON;
